import React from 'react'
import { useTranslation,Trans  } from 'react-i18next';
const Map = () => {
 const { t } = useTranslation();
    return (
        <>
            <section className='lyt-section typ-map-section'>
                <div className='container'>

                    <div className='bs-grid-box'>
                        <div className='box'>
                            <span className="icon icon-call"></span>

                            <div className='content'>
                                <div className='title'> {t('haveAQuestion')}</div>
                                <div>
                                    <a className='common-text' href='tel:+918169231135'>+91 8169231135</a>
                                </div>
                                <div>
                                    <a className='common-text mb-0' href='tel:+919820235017'>+91 9820235017</a>
                                </div>
                            </div>
                        </div>

                        <div className='box'>
                            <span className="icon icon-mail"></span>

                            <div className='content'>
                                <div className='title'> {t('contactUsAt')}</div>
                                <div>
                                    <a className='common-text' href='mailto:grsf.helpdesk@gmail.com'>grsf.helpdesk@gmail.com</a>
                                </div>
                                {/* <div>
                                    <a className='common-text mb-0' href='mailto:contactus@example.com'>contactus@example.com</a>
                                </div> */}
                            </div>
                        </div>

                        <div className='box'>

                            {/* <span className="icon icon-love"></span> */}
                            <img src='./images/for_us.svg' className='img-fluid' alt='icon'/>

                            <div className='content'>
                                <div className='title'>{t('followUs')}</div>

                                <div className='social-icons'>
                                    <a href='https://www.youtube.com/@mahasewa01'>
                                        <span className="icon icon-youtube"></span>
                                    </a>
                                    {/* <a href='https://www.facebook.com'>
                                        <span className="icon icon-facebook"></span>
                                    </a>
                                    <a href='https://twitter.com'>
                                        <span className="icon icon-twitter"></span>
                                    </a>
                                    <a href='https://www.instagram.com'>
                                        <span className="icon icon-insta"></span>
                                    </a>
                                    <a href='https://www.linkedin.com'>
                                        <span className="icon icon-linkdin"></span>
                                    </a> */}
                                </div>
                            </div>
                        </div>


                    </div>

                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.762177495102!2d72.8454326!3d19.1180864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9d18bde1e57%3A0xbb165138dc9c7447!2sMaharashtra%20Societies%20Welfare%20Association!5e0!3m2!1sen!2sin!4v1736321430824!5m2!1sen!2sin&hl=mr" width="600" height="450" frameBorder={0} allowFullScreen></iframe>
                </div>
            </section>
        </>
    )
}

export default Map